/* Release: 8ad4bfd8 (Latest – unreleased) */

import { useState } from 'react';
import { IconButton } from 'subframe/components/IconButton';
import { Button } from 'subframe/components/Button';
import { Dialog } from 'subframe/components/Dialog';
import styles from './UpgradesCancelDialog.module.scss';
import { AtomicTooltip } from 'components/design-system';
import {
  getUpgradeModeHumanReadable,
  UpgradeViewMode,
} from './UpgradesHelpers';

function UpgradesCancelDialog({
  onConfirm,
  mode,
  open,
  setOpen,
}: {
  onConfirm: () => void;
  mode: UpgradeViewMode;
  open: boolean;
  setOpen: (open: boolean) => void;
}) {
  return (
    <div
      style={{
        display: 'contents',
      }}
    >
      <Dialog open={open} onOpenChange={setOpen}>
        <Dialog.Content className="flex-[0_0_auto] h-auto w-[320px]">
          <div className={styles['stack-fe8d2707']}>
            <div className={styles['stack-a5652404']}>
              <span className={styles['text-67f523a2']}>
                Cancel the {getUpgradeModeHumanReadable(mode)}?
              </span>
              <IconButton
                size="medium"
                icon="FeatherX"
                onClick={() => {
                  setOpen(false);
                }}
              />
            </div>
            <div className={styles['stack']}>
              <span className={styles['bodyText']}>
                Are you sure you want to cancel this{' '}
                {getUpgradeModeHumanReadable(mode)}?
              </span>
              <span className={styles['bodyText']}>
                Canceling this {getUpgradeModeHumanReadable(mode)} will discard
                all stages and steps completed so far. The action cannot be
                undone.
              </span>
              <span className={styles['bodyText']}>
                You will have to create a new{' '}
                {getUpgradeModeHumanReadable(mode)} if you wish to continue in
                the future.
              </span>
              <div className={styles['stack-88dea843']}>
                <Button
                  size="large"
                  variant="destructive-primary"
                  icon="FeatherX"
                  onClick={() => {
                    onConfirm();
                    setOpen(false);
                  }}
                >
                  {`Cancel ${getUpgradeModeHumanReadable(mode)}`}
                </Button>
              </div>
            </div>
          </div>
        </Dialog.Content>
      </Dialog>
    </div>
  );
}

export default UpgradesCancelDialog;
